import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { AppKey } from '../app/AppKey';
import { updateKeyValue } from '../store/app/action-creators';
import { useTracker } from '../tracking/useTracker';
import { StyledOAuthButton, StyledOAuthContainer, StyledOAuthErrorMessage, StyledOAuthImage, StyledOAuthText } from './OAuthButton.styles.ts';
import { OAuthToLogo, OAuthToLogoDisabled, OAuthToText } from './OAuthMapping';
import { OAuthProviders } from './OAuthProviders';
import { useOAuthSignup } from './useOAuthSignup';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OAuthButton = ({
  oauth,
  onClick,
  isLoading = false
}) => {
  const [shouldRenderErrorMessage, setShouldRenderErrorMessage] = useState(false);
  const Tracker = useTracker();
  const {
    isAssignedToVariant: isAssignedToACQ143Variant
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.never);
  const dispatch = useDispatch();
  const onButtonClick = () => {
    Tracker.signupInteraction('click-oauth-button', {
      partner: oauth
    });
    dispatch(updateKeyValue(AppKey.FirstOAuthPartnerClick, oauth));
    if (onClick) {
      onClick();
    } else {
      setShouldRenderErrorMessage(true);
    }
  };
  const {
    oAuthsEnabledByFlowConfig
  } = useOAuthSignup();
  const isAppleEnabled = oAuthsEnabledByFlowConfig[OAuthProviders.Apple];
  const logo = shouldRenderErrorMessage ? OAuthToLogoDisabled[oauth] : OAuthToLogo[oauth];
  const text = OAuthToText[oauth];
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledOAuthContainer, {
      "data-selenium": 'oauth-container',
      isAssignedToACQ143Variant: isAssignedToACQ143Variant(),
      shouldCenter: !isAssignedToACQ143Variant(),
      children: /*#__PURE__*/_jsxs(StyledOAuthButton, {
        "data-selenium": `oauth-button-${oauth}`,
        "data-test-id": `oauth-button-${oauth}`,
        disabled: shouldRenderErrorMessage,
        id: `oauth-button-${oauth}`,
        oAuth: oauth,
        onClick: onButtonClick,
        children: [logo && /*#__PURE__*/_jsx(StyledOAuthImage, {
          children: /*#__PURE__*/_jsx(UIImage, {
            className: `Image ${oauth}Image`,
            src: logo
          })
        }), text && /*#__PURE__*/_jsx(StyledOAuthText, {
          oAuth: oauth,
          children: isLoading ? /*#__PURE__*/_jsx(UILoadingSpinner, {
            size: "sm"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: text
          })
        })]
      })
    }), shouldRenderErrorMessage && /*#__PURE__*/_jsxs(StyledOAuthErrorMessage, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `views.${Step.LandingPage}.${oauth}Error`
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.LandingPage}.otherOAuths.${oauth}${
          // eslint-disable-next-line no-nested-ternary
          oauth === OAuthProviders.Microsoft ? isAppleEnabled ? '.withApple' : '.withoutApple' : ''}`
        })
      })]
    })]
  });
};